// Отправка формы
export const POST_FORM = '/bxapi/v1/form'
export const REDIRECTS = 'bxapi/v1/redirects'

export const NEWS = '/bxapi/v1/news/list'

export const DETAIL_NEW = '/bxapi/v1/news/detail'

export const LIST_VACANCIES = '/bxapi/v1/career/vacancies/list'

export const VACANCIES_FILTERS = '/bxapi/v1/career/vacancies/filters'

export const DETAIL_VACANCY = '/bxapi/v1/career/vacancies/'

export const SEARCH = '/bxapi/v1/search'

export const EXCLUDED_REGIONS = '/bxapi/v1/career/stat-agentom/exclude-regions'

export const EXCLUDED_OFFICES = '/bxapi/v1/career/stat-agentom/exclude-offices'

export const HH_VACANCIES = '/bxapi/v1/career-hh/vacancies'
export const HH_SPECIALIZATIONS = '/bxapi/v1/career-hh/specializations'
export const HH_REGIONS = '/bxapi/v1/career-hh/regions'
export const HH_SEND_FORM = '/bxapi/v1/career-hh/send-form'

export const BRAND_MEDIA_TAGS = 'bxapi/prosto/getTags'

export const BRAND_MEDIA_SECTIONS = 'bxapi/prosto/getSections'

export const BRAND_MEDIA_LEADER = 'bxapi/prosto/getMainLeader'

export const BRAND_MEDIA_ARTICLES = 'bxapi/prosto/getArticles'

export const BRAND_MEDIA_ARTICLES_TAGS = 'bxapi/prosto/getTagsPage'

export const BRAND_MEDIA_ARTICLE = 'bxapi/prosto/getArticle'

export const BRAND_MEDIA_LIKE = 'bxapi/prosto/likes/increment'

export const BRAND_MEDIA_DISLIKE = 'bxapi/prosto/dislikes/increment'

export const BRAND_MEDIA_NEUTRAL = 'bxapi/prosto/neutral/increment'

export const BRAND_MEDIA_VIEW = 'bxapi/prosto/views/increment'

export const BRAND_MEDIA_AUTHOR = 'bxapi/prosto/getAuthor'

export const BRAND_MEDIA_AUTHORS = 'bxapi/prosto/getAuthor/list'

export const CHECK_QUOTATION = '/api/v1/rgs/risky/check-client'

export const SPARES_ELEMENTS = '/bxapi/v1/spares/elements'

export const CARDS_LK = '/bxapi/v1/site/cards-lk'

export const BRAND_MEDIA_ARTICLES_LIST = '/bxapi/prosto/articles/map'
